module.exports = __webpack_public_path__ + "static/scale-model-of-winnwood-park-in-richardson-texas-72d74484d1f5c43ae9e2f49c31cfcc1e.png";